import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: grid;
  gap: ${theme.spacing.md};
  grid-template-columns: 3fr 2fr 1fr;

  .fullWidth,
  .partners,
  .commercial,
  .cancel {
    display: grid;
  }

  .fullWidth {
    grid-column: 1 / 4;
  }
  .cancel {
    grid-column: 2 / 4;
  }

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: 2fr 1fr;
    .fullWidth,
    .partners,
    .commercial,
    .cancel {
      grid-column: 1 / 3;
    }
  }
`
